"use strict";

(function () {
  'use strict';

  angular.module('special-filters', []).filter('specialType', specialType).filter('invalidSpecials', invalidSpecials);

  function specialType() {
    return function (specialsArr, specialType) {
      if (specialsArr) {
        return specialsArr.filter(function (special) {
          return special.specialType === specialType;
        });
      }
    };
  }

  function invalidSpecials() {
    return function (specialsArr) {
      if (specialsArr) {
        return specialsArr.filter(function (special) {
          return !special.valid;
        });
      }
    };
  }
})();